<template>
    <div>
        <div class="Mask">
            <div class="Mask-bj" @click="$emit('printPage')"></div>
        <div class="nerk">
        <div class="pb-3 nerk-kls" id="printMe">
            <div class="logos">
                <img :src="!_IsDevMode?'/images/public/guide_logo.png':'/images/public/guide_logo_1.png'">
            </div>
            <div class="topsnqsn">
                <div class="d-flex flex-wrap nf">
                <p class="">订单号：<span>{{OrderDetail.oid}}</span></p>
                </div>
                <!-- <div class="d-flex flex-wrap nl" v-if="OrderDetail.deal_time!='0'">
                     <p>成交时间：<span>{{OrderDetail.deal_time| formatTimestamp(1)}}</span></p>
                </div> -->
            </div>
            <div>
            <div class="d-flex flex-wrap pt-2 pl-46 bttoms" v-if="($GFUN.isInArray([6,7,8,9],OrderDetail.status)&&storeInfo.type===2||$GFUN.isInArray([6,7,8,9],OrderDetail.status)&&storeInfo.type===99)||(OrderDetail.hotel_top_pic&&storeInfo.type===2||OrderDetail.hotel_top_pic&&storeInfo.type===99)">
                <h4 class="wl-15" >酒店信息</h4>
                <div class="pl-46">
                    <p>
                    <span class="liesnqs title">
                        {{OrderDetail.hotel_title||'无'}}
                        <!-- <i class="star">{{OrderDetail.hotel_star | formatVar('HotelStar')}}</i>
                        <i class="offer_time">报价时间：{{OrderDetail.deal_time| formatTimestamp(1)}}</i> -->
                    </span>
                    </p>
                    <p>联&ensp;系&ensp;人：<span>{{OrderDetail.offer_name}}</span>
                    <span class="pl-4">手机号：
                        <span>{{OrderDetail.offer_mobile}}</span>
                    </span>
                    </p>
                    <p>需求说明：<span>{{OrderDetail.offer_remark||'无'}}</span></p>
                </div>
            </div>
            <div class="bttom d-flex flex-wrap pt-2 pl-46 " v-if="storeInfo.type===3">
                <h4  class="wl-15">采购商信息</h4>
                <div class="pl-46">
                <h4 class="text-ls">{{OrderDetail.travel_title}}</h4>
                <p>联系人：<span>{{OrderDetail.send_name}}</span></p>
                <p>手机号：
                    <span>{{OrderDetail.send_mobile}}</span>
                </p>
                </div>
            </div>
            <div class="d-flex flex-wrap pt-2 pl-46 bttom">
                <h4 class="wl-15">用房信息</h4>
                <div class="pl-46">
                    <p>订单类型：
                    <span>{{OrderDetail.order_type==1?'住宿订单':'纯会议订单'}}</span>
                    <span class="operationxiug" >
                        <slot name="modify"></slot>
                    </span>
                    </p>
                    <p>团队类型：<span>{{OrderDetail.team_type==1?'旅游团':'会议团'}}</span><span v-if="OrderDetail.team_type==1">({{OrderDetail.num}}人)</span></p>
                    <p>团&emsp;&emsp;号：<span>{{OrderDetail.title}}</span></p>
                    
                    <!-- <p v-if="OrderDetail.status>4" class="linheigth"><span>订&emsp;&emsp;金：</span><span  v-if="OrderDetail.deposit!=0">{{OrderDetail.deposit}}</span>{{OrderDetail.deposit==0?'免订金':'元'}}</p> -->
                    <p v-if="OrderDetail.order_type==1"><span>早餐需求：</span><span>{{OrderDetail.breakfast}}</span></p>
                    <p v-if="OrderDetail.order_type==1">入离日期：<span >{{OrderDetail.date_in | formatTimestamp(2)}}~{{OrderDetail.date_out | formatTimestamp(2)}}</span>（共{{OrderDetail.days}}晚）</p>
                    <p v-if="OrderDetail.other"><span>会议设施：</span><span class="mr-1 lin-height-20" :key="item" v-for="item in starns(OrderDetail.other,'meetRoomObj') ">{{item}}</span></p>
                    <p v-if="storeInfo.type!==3&&OrderDetail.appoint_store_id==0"><span>星级需求：</span><span  class="mr-1" v-for="item in starns(OrderDetail.star,'HotelStar')" :key="item">{{item}}</span></p>
                    <p v-if="storeInfo.type!==3&&OrderDetail.appoint_store_id==0">用房区域：<span>{{OrderDetail.province_name}}省&ensp;{{OrderDetail.city_name}}市&ensp;{{OrderDetail.district_name}}</span></p>
                    <p v-if="OrderDetail.remark"><span>需求说明：</span><span>{{OrderDetail.remark||'无'}}</span></p>
                    <!--住宿订单-->
                    <template v-if="OrderDetail.order_type==1">
                        <p class="divs top1"><span v-if="(OrderDetail.status==99?!OrderDetail.hotel_top_pic?1:OrderDetail.status:OrderDetail.status)<5">用房需求：</span>
                            <!--询价前-->
                            <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd" v-if="(OrderDetail.status==99?!OrderDetail.hotel_top_pic?1:OrderDetail.status:OrderDetail.status)<5"><!--(storeInfo.type==2?5:100)-->
                                <thead>
                                <tr>
                                    <th>房型</th>
                                    <th>间数</th>
                                </tr>
                                </thead>
                                <template v-for="item in OrderDetail.room_need_arr.list" >
                                <tbody v-if="item.room_num!=0" :key="item.type">
                                    <tr>
                                    <td>
                                        {{item.type | formatVar('roomStyle')}}
                                    </td>
                                    <td>{{item.room_num}} 间</td>
                                    </tr> 
                                </tbody>
                                </template>
                            </table>
                            <!--询价后-->
                            <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd" v-if="(OrderDetail.status==99?OrderDetail.hotel_top_pic?OrderDetail.status:1:OrderDetail.status)>4&&OrderDetail.need_mode!=1"><!--(storeInfo.type==2?4:100)-->
                                <thead>
                                <tr>
                                    <th colspan="3">用房需求</th>
                                    <th colspan="3">酒店报价</th>
                                </tr>
                                </thead>
                                <thead>
                                <tr>
                                    <th>房型</th>
                                    <th>间数</th>
                                    <th>晚数</th>
                                    <th>房名</th>
                                    <th>单价</th>
                                    <th>早餐</th>
                                </tr>
                                </thead>
                                <template v-for="item in OrderDetail.room_need_arr.list" >
                                <tbody v-if="item.room_num!=0" :key="item.type">
                                    <tr>
                                    <td>
                                        {{item.type | formatVar('roomStyle')}}
                                    </td>
                                    <td>{{item.room_num}} 间</td>
                                    <td>{{item.night_num}} 晚</td>
                                    <td>{{item.offer_title}}
                                    </td>
                                    <td><span>{{item.offer_price}}元/晚</span></td>
                                    <td>{{OrderDetail.breakfast_type }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </table>
                            <QuotationForm :priceArrs='OrderDetail.room_need_arr.list' :postInfo='OrderDetail' v-else/>
                        </p>
                    <!-- <p>早餐需求：<span>{{OrderDetail.breakfast | formatVar('breakfastArr')}}</span></p> -->
                    </template>
                    <div v-if="OrderDetail.meeting_need_arr!=''"  class="divs">
                        <span v-if="(OrderDetail.status==99?!OrderDetail.hotel_top_pic?1:OrderDetail.status:OrderDetail.status)<5">会议需求：</span>
                        <!--询价前-->
                        <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd" v-if="(OrderDetail.status==99?!OrderDetail.hotel_top_pic?1:OrderDetail.status:OrderDetail.status)<5"><!--(storeInfo.type==2?5:100)-->
                            <thead>
                            <tr>
                                <th>开会日期</th>
                                <th>时段</th>
                                <th>布局</th>
                                <th>出席人数</th>
                                <th>要求面积</th>
                            </tr>
                            </thead>
                            <tbody v-for="item in OrderDetail.meeting_need_arr.list" :key="item.type">
                            <tr>
                                <td>{{item.date | formatTimestamp()}}</td>
                                <td>{{item.timeslot| formatVar('TimeSlots')}}</td>
                                <td>{{item.type | formatVar('LayoutTypes')}}</td>
                                <td>{{item.num}}人</td>
                                <td>{{item.area}}㎡</td>
                            </tr>
                            </tbody>
                        </table>
                        <!--询价后-->
                        <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd" v-if="(OrderDetail.status==99?OrderDetail.hotel_top_pic?OrderDetail.status:1:OrderDetail.status)>4"><!--(storeInfo.type==2?4:100)-->
                            <thead>
                            <tr>
                                <th colspan="5">会议需求</th>
                                <th colspan="2">酒店报价</th>
                            </tr>
                            </thead>
                            <thead>
                            <tr>
                                <th>开会日期</th>
                                <th>时段</th>
                                <th>布局</th>
                                <th>出席人数</th>
                                <th>要求面积</th>
                                <th>名称</th>
                                <th>价格</th>
                            </tr>
                            </thead>
                            <tbody v-for="item in OrderDetail.meeting_need_arr.list" :key="item.type">
                            <tr>
                                <td>{{item.date | formatTimestamp()}}</td>
                                <td>{{item.timeslot| formatVar('TimeSlots')}}</td>
                                <td>{{item.type | formatVar('LayoutTypes')}}</td>
                                <td>{{item.num}}人</td>
                                <td>{{item.area}}㎡</td>
                                <td>{{item.offer_title}}</td>
                                <td><span>{{item.offer_price}}元</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="flex-wrap mb-3 nrk" v-if="OrderDetail.add_need_arr.list">
                        <!--询价后-->
                        <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd">
                                <thead>
                                <tr>
                                    <th colspan="2">附加需求</th>
                                </tr>
                                </thead>
                                <thead>
                                    <tr>
                                    <th>名称</th>
                                    <th>金额</th>
                                    </tr>
                                </thead>
                                <tbody v-for="item in OrderDetail.add_need_arr.list" :key="item.type">
                                    <tr>
                                    <td>{{item.add_title }}</td>
                                    <td><span class=" pl-2">{{item.add_price}} </span>元</td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                </div>
            </div>
            <set-guide class="mb-2" @getDetail="$emit('getDeatail')" v-if="$GFUN.isInArray([6,7,8,9],OrderDetail.status)" :swit='false'/>
            <div class="moneyns " v-if="OrderDetail.price!=0">
                    <div class="money-Record">
                    <div><p>订单金额：</p><span class=" fw">¥{{OrderDetail.price}}</span></div>
                    <div v-if="OrderDetail.status>4&&OrderDetail.deposit>0"><p>订&emsp;&emsp;金：</p>
                        <span v-if="OrderDetail.deposit!=0">¥{{OrderDetail.deposit}}</span>
                        <span v-else class="h6">免订金</span>
                    </div>
                    <!-- <div v-if="OrderDetail.deposit!=0"><p>尾款：</p><span>¥{{OrderDetail.price-OrderDetail.deposit}}</span></div> -->
                    <div v-if="OrderDetail.price_pay>0"><p>{{storeInfo.type===3?'已&ensp;收&ensp;款':'已&ensp;支&ensp;付'}}：</p><span class="fw fotn-size-18">¥{{OrderDetail.price_pay/100>OrderDetail.price&&OrderDetail.broker>0?OrderDetail.price:OrderDetail.price_pay/100}}</span></div>
                    <div v-if="OrderDetail.price_pay/100>OrderDetail.price&&OrderDetail.broker>0&&$GFUN.isInArray([2,99],storeInfo.type)"><p>代&ensp;收&ensp;款：</p><span class="fw fotn-size-18">¥{{OrderDetail.price_pay/100}}</span></div>
                    <div v-if="OrderDetail.offset_pay>0&&OrderDetail.price_pay>0"><p>{{storeInfo.type===3?'待&ensp;收&ensp;款':'待&ensp;支&ensp;付'}}：</p><span class="fw fotn-size-18">¥{{OrderDetail.offset_pay/100}}</span></div>
                    </div>
            </div>
            <div class="d-flex flex-wrap pt-2 pl-46 mb-1" v-if="$GFUN.isInArray([2,99],storeInfo.type)">
                <h4 class="wl-15">采购商信息</h4>
                <div class="pl-46">
                <h4 class="text-ls">{{OrderDetail.travel_title}}</h4>
                <p>联系人：<span>{{OrderDetail.send_name}}</span></p>
                <p>手机号：
                    <span>{{OrderDetail.send_mobile}}</span>
                </p>
                </div>
            </div>
            <div class="d-flex flex-wrap pt-2 pl-46 mb-1" v-if="OrderDetail.my_offer">
                <h4 class="wl-15" v-if="OrderDetail.my_offer!=''">酒店信息</h4>
            <div class="myoffer">
            <template>
              <div v-for="item in OrderDetail.my_offer" :key="item.id" class="myoffer-lie borderNone"> 
                <div class="pl-46">
                    <p>
                    <span class="liesnq">
                        <i class="title">{{item.hotel_title||'无'}}</i>
                        <!-- <i class="offer_time">{{OrderDetail.my_offer.hotel_star | formatVar('HotelStar')}}</i>
                        <i class="offer_time">报价时间：{{OrderDetail.my_offer.offer_time||OrderDetail.my_offer.deal_time| formatTimestamp(1)}}</i> -->
                    </span>
                    </p>
                    <p>联&ensp;系&ensp;人：
                    <span class="hsns">{{item.offer_name}}</span>
                    <span class="pl-4">手机号：
                        <span class="hsns">{{item.offer_mobile}}</span>
                    </span>
                    </p>
                    <p v-if="item.rmine==1">房间报价：
                    <span>
                        <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd">
                            <template v-for="(room,index) in item.room_offer_arr|| OrderDetail.room_need_arr.list">
                            <tbody v-if="room.num!=0" :key="index">
                                <tr>
                                <td>
                                    {{room.offer_title}}
                                    </td>
                                <td><span>{{room.offer_price}}</span>元/晚</td>
                                </tr>
                            </tbody>
                            </template>
                        </table>
                    </span>
                    </p>
                    <p v-if="item.rmine==2">会议报价：
                    <span>
                        <table border="1" align="center" cellpadding="10" cellspacing="5" class="lisd">
                            <tbody v-for="(meet,index) in item.meeting_offer_arr|| OrderDetail.meeting_need_arr" :key="index">
                            <tr>
                                <td>{{meet.date | formatTimestamp()}}</td>
                                <td>{{meet.timeslot| formatVar('TimeSlots')}}</td>
                                <td>
                                {{meet.offer_title}}
                                </td>
                                <td><span class="">{{meet.offer_price}}</span>元</td>
                            </tr>
                            </tbody>
                        </table>
                    </span>
                    </p>
                    <p v-if="item.rmine>3">
                    <span>订&emsp;&emsp;金：</span>
                    <span class="" v-if="item.deposit!=0">{{item.deposit}}</span>
                    <span>{{item.deposit==0?'免订金':'元'}}</span>
                    </p>
                    <p v-if="item.rmine==3">酒店回复：接不了</p>
                    <p><span>{{item.rmine==3?'原&emsp;&emsp;因：':'报价说明：'}}</span><span>{{item.offer_remark||'无'}}</span></p>
                </div>
                    </div>
                </template>
            </div>
            </div>
            </div>
            <div class="d-flex flex-wrap pt-2 pl-46 topttom">
                <h4 class="wl-15"></h4>
                <div class="pl-46">
                <p v-if="OrderDetail.add_time&&OrderDetail.add_time!=0" class="lieps "><span>发布时间：</span><span>{{OrderDetail.add_time | formatTimestamp(1)}}</span></p>
                <p v-if="OrderDetail.offer_time>0" class="lieps mb-1"><span>报价时间：</span><span>{{OrderDetail.offer_time| formatTimestamp(1) }}</span></p>
                <p v-if="OrderDetail.deal_time&&OrderDetail.deal_time!=0" class="lieps "><span>成交时间：</span><span>{{OrderDetail.deal_time | formatTimestamp(1)}}</span></p>
                <p v-if="OrderDetail.edit_time&&OrderDetail.edit_time!=0" class="lieps "><span>修改时间：</span><span>{{OrderDetail.edit_time | formatTimestamp(1)}}</span></p>
                <p v-if="OrderDetail.pay_time&&OrderDetail.pay_time!=0" class="lieps "><span>支付时间：</span><span>{{OrderDetail.pay_time | formatTimestamp(1)}}</span></p>
                <p v-if="OrderDetail.cancel_time&&OrderDetail.cancel_time!=0" class="lieps "><span>取消时间：</span><span>{{OrderDetail.cancel_time | formatTimestamp(1)}}</span></p>
                <p v-if="OrderDetail.end_time&&OrderDetail.end_time!=0" class="lieps mb-1"><span>完成时间：</span><span>{{OrderDetail.end_time | formatTimestamp(1)}}</span></p>
                </div>
            </div>
        </div>
            <div class="anlies lisqd" @click="$emit('printPage')"> 关闭</div>
            <div class="anlies" @click="printck"> 打印订单</div>
            </div>
        </div>
    </div>
</template>

<script>
import print from 'print-js'
import SetGuide from '../../SetGuide/SetGuide';
import HotelOrderIFlag from '../../../OrderLists/HotelOrderIFlag'
import QuotationForm from '../DateTable/QuotationForm'
import { mapState,mapGetters,mapActions } from 'vuex'
  export default {
    data() {
      return {
        mle:false,                            //查看开关
        clockCount:'',
        flagtype:'',
        flagtiem:[],
        showConfirmPanel:false,
      }
    },
    components: {SetGuide,HotelOrderIFlag,QuotationForm},
    props:{
        OrderDetail:{}
    }, 
    computed:{
      ...mapGetters(['storeInfo','isAdmin']),
      ...mapState(['RoomMeetDetail']),
      orderId () { return Number(this.$route.query.orderId) },
    },
    mounted() {
    },
    methods: {
        //星级需求
        starns(e,type){
            let result
            if(!e)return['无']
            if(!e.toString().includes(',')){
            result=new Array(e)
            }else{
            if(!Array.isArray(e)){
                result=e.split(',')
            }
            }
            let n=this.$options.filters['formatStars'](result,type);
            return n
        },
      meetRoomObj(e){
        let result
        if(!e)return['无']
        if(Array.isArray(e)){
          result=e
        }else{
          result=e.split(',')
        }
        let n=this.$options.filters['formatmeetRoomObj'](result);
        return n
      },
        printck(){
            setTimeout(function () {
            print({
                printable: 'printMe',
                type: 'html',
                scanStyles:false,
                targetStyles: ['*'],
                style:
                ".mr-1{margin-right: 0.25rem !important;}.h6{font-size: 14px !important;}.moneyns span{margin-top: 13px;} .fw{font-weight: bold;}.moneyns{margin-left: auto;line-height: 19px;font-size: 16px;width: 90%;;border-bottom: 1px #eee solid;padding: 14px 5%;overflow: hidden;}.money-Record{width: 140px;float: right;position: relative;}.money-Record>div{display: flex;justify-content: space-between;text-align: right;}.money-Record div p{width: 70%;font-size: 14px;margin-bottom: 8px;}.moneyns p{justify-content: center;}.topttom{border-top: 1px #eee solid;margin-top: 12px;}.w120{width: 40px;} .divs .lisd{float: left; width: 100%;}.myoffer{width: 80%;}.myoffer-lie{padding-bottom: 15px;overflow: hidden;border-bottom: 1px #eee solid;margin-bottom: 15px;position: relative;}.bttoms{ padding-bottom: 0.5rem;border-bottom: 1px #eee solid;overflow: hidden;}.nl {float: right;}.nnsp p {padding:0; margin: 0; margin-left: 86px;padding-left: 1rem;width: 60px;text-align: right;float: left;}.nnsp{border-bottom: 1px #eee solid;padding: 16px 0;overflow: hidden;}.money {    margin-left: auto;line-height: 19px;font-size: 16px;width: 90%;;border-bottom: 1px #eee solid;padding: 14px 5%;overflow: hidden;}.pl-4 {padding-left:20px}.divs{width: 100%;justify-content: left;margin-bottom: 6px;font-size: 12px;margin-top: 8px;overflow: hidden; display: flex;}.top1{margin-top: 12px;}.divs span{float: left;}.title {font-style: normal;font-size: 14px;font-weight: bold;color: #333;display: block;text-align: left;cursor: pointer;}.pl-46 p {line-height: 9px;margin-bottom: 4px;display: flex;flex-wrap: wrap;font-size: 12px;justify-content: left;}.text-ls {text-align: left;margin-bottom: 0.5rem;}.pl-46 {position: relative;min-height: 60px;padding-left: 1rem !important;}.wl-15 {width: 70px;text-align: left;}.d-flex {display: flex !important;}.flex-wrap {-ms-flex-wrap: wrap !important;flex-wrap: wrap !important;}.pt-2 {padding-top: 0.5rem !important;}.bttom {border-bottom: 1px #eee solid;padding-bottom: 12px;}.pl-46 {position: relative;min-height: 60px;padding-left: 1rem !important;}.nf {float: left;line-height: 32px;margin-left: 12px;}.topsnqsn {width: 97%;padding: 0.5rem 0;margin-left: 1%;padding-right: 2%;margin: 0 auto;border-bottom: 1px #eee solid;font-weight: bold;overflow: hidden;font-size: 14px;}.logos {text-align: left; margin-top: 10px;}body{font-size: 12px;}img{width: 160px;}i{font-style:normal;}table {border-collapse: collapse;display: inline-block;border:none} th, td {border: 1px solid #000; padding:8px;text-align: center; }"
            })
            }, 500)
        },
      ...mapActions(['getRoomDetail','getMeetDetail','GetOrderDetail']),
    },
  }
</script>
<style scoped>
    table {
        border-collapse: collapse;
    }
    .lisd td,.lisd th {
    padding: 4px 10px;
    font-size: 12px;
    text-align: center;
}
    .Mask{
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 999;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .Mask-bj{
        background: rgba(0, 0, 0, .4);
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .nerk{
        width: 990px;
        background-color: #fff;
        position: relative;
        z-index: 9;
        margin: 0 auto;
        padding: 40px 0;
        max-height: 96%;
    }
    .nerk-kls{
        max-height: 90%;
        overflow: auto;
    }
    .liesnq{
        margin-left: 0;
    }
    .topsnq{
        overflow: hidden;
    }
    .topsnq{
        width: 97%;
        padding: 10px 0;
        margin-left: 1%;
        padding-right: 2%;
        margin: 0 auto;
        border-bottom: 1px #eee solid;
        font-weight: bold;
    }
    .anlies{
        width: 80px;
        line-height: 40px;
        text-align: center;
        height: 40px;
        background-color: var(--smtc-color-primary);
        color: #fff;
        float: right;
        margin-right: 1.5%;
        border-radius: 5px;
        cursor: pointer;
    }
    .lisqd{
        margin-right: 5%;
        background-color: #eee;
        color: #666;
    }
    .logos{
        text-align: left;
        margin-top: 10px;
    }
    .logos img{
        width: 146px;
        margin-left: 10px;
    }
    .pl-46 {
        position: relative;
        min-height: 60px;
        padding-left: 1rem !important;
    }
    .pl-46 p{
        margin-bottom: 4px;
        display: flex;
        flex-wrap: wrap;
        font-size: 12px;
    }
    .bttoms{
        padding-bottom: 0.5rem;
        border-bottom: 1px #eee solid;
    }
    .topsnqsn{
        width: 97%;
        padding: 0.5rem 0;
        margin-left: 1%;
        padding-right: 2%;
        margin: 0 auto;
        border-bottom: 1px #eee solid;
        font-weight: bold;
        overflow: hidden;
        font-size: 14px;
    }
    .text-ls{
        text-align: left;
        margin-bottom: 0.5rem;
    }
    .divs{
        margin-bottom: 4px;
        font-size: 12px;
        display: flex;
        overflow: hidden;
        justify-content: left;
        width: 100%;
    }
    .divs span{
        float: left;
    }
    .linheigth{
        line-height: 20px;
    }
    .moneyns {
        margin-left: auto;
        line-height: 19px;
        font-size: 16px;
        width: 90%;
        border-bottom: 1px solid #eee;
        padding: 14px 5%;
        overflow: hidden;
    }

  .money-Record{
    min-width: 140px;
    float: right;
    position: relative;
  }
  .money-Record>div{
    display: flex;
    justify-content: space-between;
    text-align: right;
    
  }
  .money-Record div p{
    width: 70%;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .money-Record div span{
    min-width: 50px;
  }
  .topttom{
    border-top: 1px solid #eee;
  }
  .topttom p {
    line-height: 18px;
    padding-bottom: 0;
    color: #666;
}
.wl-15 {
    width: 70px;
}
.nf,.travel {
    float: left;
    margin-left: 12px
} 
</style>